"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
_moment.default.locale('pt-br');
var _default = exports.default = {
  props: {
    shiftHours: {
      type: Object,
      required: true
    },
    timesheetsDaily: {
      type: Array,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    farm: {
      type: Object,
      required: true
    },
    startDate: {
      type: Date,
      required: true
    },
    endDate: {
      type: Date,
      required: true
    }
  },
  methods: {
    formatWeekdays: function formatWeekdays(weekdays) {
      if (!weekdays) {
        return '';
      }
      var WEEKDAY_LABELS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
      return weekdays.filter(function (n) {
        return Number.isInteger(n) && n >= 0 && n <= 6;
      }).map(function (n) {
        return WEEKDAY_LABELS[n];
      }).join(', ');
    },
    formatMonthAndYear: function formatMonthAndYear(date) {
      return date ? (0, _moment.default)(date).format('MMMM/YYYY') : '--';
    },
    formatDateWeek: function formatDateWeek(date) {
      return date ? (0, _moment.default)(date).format('ddd DD/MM') : '--';
    },
    formatDate: function formatDate(date) {
      return date ? (0, _moment.default)(date).format('DD/MM/YYYY') : '--';
    },
    formatTime: function formatTime(date) {
      return date ? (0, _moment.default)(date).format('HH:mm') : '--';
    },
    formatSeconds: function formatSeconds(seconds) {
      var totalMinutes = Math.floor((seconds || 0) / 60);
      var hours = Math.floor(totalMinutes / 60);
      var minutes = String(totalMinutes % 60).padStart(2, '0');
      return "".concat(hours, ":").concat(minutes);
    }
  }
};